import type { OutgoingMessage } from '../types/messages';

export class MessageQueue {
  private queue: OutgoingMessage[] = [];
  private maxSize: number;

  constructor(maxSize = 100) {
    this.maxSize = maxSize;
  }

  enqueue(message: OutgoingMessage): void {
    if (this.queue.length >= this.maxSize) {
      this.queue.shift(); // Remove oldest
    }
    this.queue.push(message);
  }

  flush(): OutgoingMessage[] {
    const messages = [...this.queue];
    this.queue = [];
    return messages;
  }

  size(): number {
    return this.queue.length;
  }

  clear(): void {
    this.queue = [];
  }
}
